/**
 * A composable for managing the state of a help area content identifier.
 *
 * Provides a reactive state to track and manage the current CMS content ID
 * for help or support-related sections.
 *
 * @returns {Object} An object containing the CMS content ID state
 *
 * @example
 * const { cmsContentId } = useHelpArea()
 *
 * // Set or access the current CMS content ID
 * cmsContentId.value = 'help-section-123'
 *
 * @remarks
 * - Uses Nuxt's useState for reactive state management
 * - Initializes with an empty string
 * - Useful for dynamically loading or tracking help content
 */
export const useHelpArea = () => {
  /**
   * Reactive state for storing the current CMS content ID.
   * @type {Ref<string>}
   */
  const cmsContentId = useState('cms-content-id', () => '')

  return { cmsContentId }
}
